import React, { useEffect, createElement } from 'react';
import { useQuizState } from './hooks/useQuizState';
import { IntroPage } from './components/IntroPage';
import { QuizQuestion } from './components/QuizQuestion';
import { LoadingScreen } from './components/LoadingScreen';
import { ResultsPage } from './components/ResultsPage';
import { CheckoutPage } from './components/CheckoutPage';
// Extend window for fbq
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  const {
    currentStep,
    currentQuestion,
    currentQuestionIndex,
    totalQuestions,
    dogName,
    setDogName,
    setAnswer,
    nextQuestion,
    goToStep,
    getRiskLevel
  } = useQuizState();
  // Initialize Meta Pixel
  useEffect(() => {
    if (window.fbq) return;
    const f = window as any;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', '1297003075665954');
    window.fbq('track', 'PageView');
  }, []);
  // Scroll to top on step change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep, currentQuestionIndex]);
  return <main className="min-h-screen bg-background font-sans text-text-main antialiased selection:bg-primary/20" data-id="element-0">
      {currentStep === 'intro' && <IntroPage onStart={() => goToStep('quiz')} data-id="element-1" />}

      {currentStep === 'quiz' && <QuizQuestion question={currentQuestion} dogName={dogName} totalQuestions={totalQuestions} currentQuestionIndex={currentQuestionIndex} onAnswer={setAnswer} onNext={nextQuestion} setDogName={setDogName} data-id="element-2" />}

      {currentStep === 'loading' && <LoadingScreen dogName={dogName} onComplete={() => goToStep('results')} data-id="element-3" />}

      {currentStep === 'results' && <ResultsPage dogName={dogName} riskLevel={getRiskLevel()} onCheckout={() => goToStep('checkout')} data-id="element-4" />}

      {currentStep === 'checkout' && <CheckoutPage dogName={dogName} data-id="element-5" />}
    </main>;
}